module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "fade-in-down"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h4', {
    staticClass: "m-n font-thin h4"
  }, [_vm._v("Vaga: " + _vm._s(_vm.vagaDesejada.nome))]), _vm._v(" "), _c('span', {
    staticClass: "label no-radius bg-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "label m-l-n-xxs no-radius bg-success"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "visible-xs m-t-lg"
  }), _vm._v(" "), _c('u-button', {
    staticClass: "btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print",
    attrs: {
      "tabindex": "1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deletar.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit m-r-xs"
  }), _vm._v(" Deletar\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right pull-none-xs hidden-print m-t-xs m-r",
    staticStyle: {
      "clear": "left"
    },
    attrs: {
      "to": {
        name: 'trabalhe.conosco.index'
      }
    }
  }, [_c('strong', {
    staticClass: "label no-radius bg-info"
  }, [_vm._v("Voltar")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-4"
  }, [_c('p', [_vm._v("\n              Nome: "), _c('strong', [_vm._v(_vm._s(_vm.projeto.nome))]), _vm._v(" "), _c('br'), _vm._v("\n              E-mail: "), _c('strong', [_vm._v(_vm._s(_vm.projeto.email))]), _vm._v(" "), _c('br'), _vm._v("\n              CPF: "), _c('strong', [_vm._v(_vm._s(_vm._f("formataCpf")(_vm.projeto.cpf)))]), _vm._v(" "), _c('br'), _vm._v("\n              Data de Nascimento: "), _c('strong', [_vm._v(_vm._s(_vm._f("dataFilter")(_vm.projeto.nascimento.date)))]), _vm._v(" "), _c('br'), _vm._v("\n              Estado Civil: "), _c('strong', [_vm._v(_vm._s(_vm.estadoCivil.nome))]), _vm._v(" "), _c('br'), _vm._v("\n              Escolaridade: "), _c('strong', [_vm._v(_vm._s(_vm.escolaridade.nome))]), _c('br'), _vm._v("\n              Possui experiência? "), _c('strong', [_vm._v(_vm._s(_vm.experiencia.nome))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-3"
  }, [_c('p', [_vm._v("\n              CEP: "), _c('strong', [_vm._v(_vm._s(_vm._f("formataCep")(_vm.projeto.cep)))]), _c('br'), _vm._v("\n              Endereço: "), _c('strong', [_vm._v(_vm._s(_vm.projeto.endereco))]), _c('br'), _vm._v("\n              Bairro: "), _c('strong', [_vm._v(_vm._s(_vm.projeto.bairro))]), _c('br'), _vm._v("\n              Cidade: "), _c('strong', [_vm._v(_vm._s(_vm.projeto.cidade))]), _c('br'), _vm._v("\n              Estado: "), _c('strong', [_vm._v(_vm._s(_vm.estado))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-md-3"
  }, [_c('p', [_vm._v("\n              Telefone: "), _c('strong', [_vm._v(_vm._s(_vm._f("formataTelefone")(_vm.projeto.telefone)))]), _c('br'), _vm._v("\n              Celular: "), _c('strong', [_vm._v(_vm._s(_vm._f("formataTelefone")(_vm.projeto.celular)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-md-2"
  }, [_c('div', {
    staticClass: "fotos-flex"
  }, [_c('div', {
    staticClass: "foto"
  }, [_c('a', {
    attrs: {
      "target": "_blank"
    }
  }, [_c('i', {
    class: ("fa fa-file-" + (_vm.__gettype(_vm.projeto.anexo)) + "-o fa-5x")
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('a', {
    staticClass: "btn btn-xs btn-block btn-success",
    attrs: {
      "href": _vm.baseUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  }), _vm._v(" Ver currículo")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t"
  }, [_c('strong', [_vm._v("Informações Complementares")]), _vm._v(" "), _c('div', {
    staticClass: "projetoText"
  }, [_vm._v(_vm._s(_vm.projeto.complementares))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14de81cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/trabalhe-conosco/components/Detalhes.vue
// module id = 1701
// module chunks = 18